import { Link } from "react-router-dom";

export default function Button({
  className,
  link = false,
  color,
  children,
  noFixedHeight = false,
  ...props
}) {
  let colorClassName =
    "bg-primary-500 hover:bg-primary-600 text-white-100 shadow-sm";
  let Component = link ? Link : "button";
  if (color === "red") {
    colorClassName = "bg-red-200 hover:bg-red-300 text-white-100 shadow-sm";
  }
  if (color === "yellow") {
    colorClassName =
      "bg-yellow-200 hover:bg-yellow-300 text-black-100 shadow-sm";
  }
  if (color === "green") {
    colorClassName = "bg-green-200 hover:bg-green-300 text-white-100 shadow-sm";
  }
  if (color === "white") {
    colorClassName =
      "bg-white-100 hover:bg-white-200 text-black-200 border border-white-300";
  }
  // Legacy usages pass color="blue", which was never a defined variant and
  // silently fell back to the default primary style below anyway.
  return (
    <Component
      className={
        "px-4 py-2 rounded-sm font-semibold text-sm transition-colors duration-150 inline-flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed " +
        (noFixedHeight ? "" : "h-11 ") +
        colorClassName +
        " " +
        className
      }
      {...props}
    >
      {children}
    </Component>
  );
}
